import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PrivacyPolicy from './Privacy Policy for yekaterinazhmud.pdf';
import TermsOfService from './TERMS OF SERVICE.pdf';
import insta from './rnb-ig.webp';
import etsy from './rnb-et.webp';
import fb from './rnb-fb.webp';
import reddit from './reddit.webp';

const Footer = () => (
  <footer className="footer bg-white pt-4 mt-4">
    <Container className="homepage-content">
      <Row className="BorderTopFooter mt-5 mb-5 align-items-center g-5">
        <Col md={8} className="footer-info-legal d-flex flex-column justify-content-center">
          <div className="footer-subtitle mb-2">Yekaterina Zhmud</div>
          <div className="footer-subtitle mb-2">Chamber of commerce Amsterdam, The Netherlands</div>
          <div className="footer-subtitle mb-3">Chamber of commerce (kvk): 81649886</div>
          <a href={TermsOfService} target="_blank" rel="noopener noreferrer" className="footer-link mb-2">Terms of Service</a>
          <a href={PrivacyPolicy} target="_blank" rel="noopener noreferrer" className="footer-link">Privacy Policy</a>
        </Col>
        <Col md={4} className="footer-social d-flex flex-column align-items-center justify-content-center">
                  <div className="footer-label">Follow me on social media</div>

          <div className="footerIcons d-flex justify-content-center gap-3 mb-3">
            <a href="https://www.instagram.com/yekaterina_zhmud/" target="_blank" rel="noopener noreferrer">
              <img className="icon" src={insta} alt="Instagram" />
            </a>
            {/* <a href="https://www.etsy.com/shop/yekaterinazhmud" target="_blank" rel="noopener noreferrer">
              <img className="icon" src={etsy} alt="Etsy" />
            </a> */}
            <a href="https://www.facebook.com/yekaterinazhmud.artist" target="_blank" rel="noopener noreferrer">
              <img className="icon" src={fb} alt="Facebook" />
            </a>
            <a href="https://www.reddit.com/user/yekaterina_zhmud" target="_blank" rel="noopener noreferrer">
              <img className="icon" src={reddit} alt="Reddit" />
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;